export default __webpack_public_path__ + "static/ideas-b426e4ac33a5ffe278e18af844646ed2.png";